import { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { Box, Grid, Button } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import { makeUtilClasses, useThemeQueries } from '../../../../../theme';
import { CircularLoading } from '../../..';
import { TextFieldSaurus } from '../../../controles/inputs';
import { EnumTipoConfig } from '../../../../../model/enums/enum-tipo-config';
import { AplicacaoModel } from '../../../../../model/api/aplicacao/aplicacao-model';
import { CredenciaisDadosModel } from '../../../../../model/api/credenciais/credenciais-dados-model';
import { EnumAplicacao } from '../../../../../model/enums/enum-aplicacao';
import { AplicacaoProps, AplicacaoRefs } from './form-aplicacao-props';
import { usePostRedirecionarCredencial } from '../../../../../data/api/gestao/credenciais-dados/post-redirecionar-credencial';
import { useToastSaurus } from '../../../../../service/app/use-cases';

export const FormCadastroAplicacao = forwardRef<
  AplicacaoRefs<CredenciaisDadosModel>,
  AplicacaoProps<AplicacaoModel>
>(({ loading, onSubmit, ...props }: AplicacaoProps<AplicacaoModel>, ref) => {
  const { isMobile } = useThemeQueries();

  const utilClasses = makeUtilClasses();
  const refInputNome = useRef<HTMLInputElement>(null);
  const {
    handleSubmit,
    control,
    register,
    reset,
  } = useForm<any>({
    criteriaMode: 'all',
    mode: 'onChange'
  });


  const { postRedirecionarCredencial } = usePostRedirecionarCredencial();
  const { showToast } = useToastSaurus();

  const postUrlRedirecionamento = async (lojaId: string, codigoAplicacao: number) => {
    try {
      const model = { ...props.credencialDados, credenciar: props.credencialDados.credenciar, codigoAplicacao: props.model?.codigoAplicacao, id: props.credencialDados.id, tpSituacao: props.credencialDados.tpSituacao }

      const response = await postRedirecionarCredencial(lojaId, codigoAplicacao, model);
      if (response.erro) throw response.erro;
      const data = response?.resultado?.data;
      window.open(data, '_blank');
    } catch (e: any) {
      showToast("error", e?.message || "Erro ao obter URL de redirecionamento");
    }
  }


  const submitAlterarDadosConta = (values: any) => {
    const credenciais: Record<string, string> = values as Record<string, string>;
    var model = new CredenciaisDadosModel()
    model.credenciar(credenciais, props.ativo, props?.model?.codigoAplicacao, props.model?.tpSituacao, props.auto)
    model.ativo = props.ativo
    delete model.credenciais.valores
    onSubmit(model);
  };

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      handleSubmit(submitAlterarDadosConta)();
    },
    resetForm: () => {
      reset();
      if (!isMobile) refInputNome.current?.focus();
    },
    fillForm: () => {
      if (!isMobile) refInputNome.current?.focus();
    }
  }));


  const validationIfood = props.model?.codigoAplicacao === EnumAplicacao.Ifood || props.model?.codigoAplicacao === EnumAplicacao.IfoodGrocery;

  const configuracaoAutorizacao = useMemo(() => {
    return props.model?.configuracoes?.configuracaoAuthorizacao?.filter(
      (campo) => campo.parametro?.trim()
    );
  }, [props.model?.configuracoes]);


  return (
    <>
      <form>
        {configuracaoAutorizacao?.map((campo) => {
          return (
            <>
              <Box my={2}>
                <div className={utilClasses.formContainer}>
                  {loading && props.showLoading ? (
                    <div className={utilClasses.controlLoading}>
                      <CircularLoading tipo="NORMAL" />
                    </div>
                  ) : null}
                </div>
                <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={12} md={12}>
                    {validationIfood && campo.parametro === "AuthorizationCode" ? (
                      <>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <Grid item xs={12} md={8}>
                            <Controller
                              {...register(campo.parametro)}
                              control={control}
                              render={({ field }) => (
                                <TextFieldSaurus
                                  tipo={campo.tipo === EnumTipoConfig.Texto ? "TEXTO" : "NUMERO"}
                                  fullWidth
                                  showStartAdornment={true}
                                  allowSubmit
                                  label={campo.descricao}
                                  placeholder={campo.descricao}
                                  {...field}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={4} md={4}>
                            <Button
                              fullWidth
                              color='primary'
                              onClick={() => { props.setAberto(1) }}
                            >
                              Validar Acesso
                            </Button>
                          </Grid>
                        </div>
                      </>
                    )
                      : campo.tipo === EnumTipoConfig.ButtonRedirecionar ? (
                        <>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                            <Grid item xs={4} md={4}>
                              <Button
                                variant="outlined"
                                fullWidth
                                color='primary'
                                onClick={() => postUrlRedirecionamento(props.loja.id, props.model?.codigoAplicacao || 0)}
                              >
                                {campo.descricao}
                              </Button>
                            </Grid>
                          </div>
                        </>
                      )
                        :
                        <>
                          <Controller
                            {...register(campo.parametro)}
                            control={control}
                            render={({ field }) => (
                              <TextFieldSaurus
                                tipo={campo.tipo === EnumTipoConfig.Texto ? "TEXTO" : "NUMERO"}
                                fullWidth
                                disabled={loading}
                                showStartAdornment={true}
                                allowSubmit
                                label={campo.descricao}
                                placeholder={campo.descricao}
                                {...field}
                              />
                            )}
                          />
                        </>
                    }
                  </Grid>
                </Grid>
              </Box>
            </>
          )
        })}
      </ form>
    </>
  );
},
);
